import { createFileRoute } from "@tanstack/react-router";
import { QuestionnairesPage } from "@/features/questionnaires";
import { patientDomainIdFromProfile } from "@/shared/lib/patient-profile";
export const Route = createFileRoute("/_consented/questionnaires")({ component: Page });
function Page() {
  const { profile } = Route.useRouteContext();
  return <QuestionnairesPage patientId={patientDomainIdFromProfile(profile)} />;
}
